import { render, staticRenderFns } from "./FBudget.vue?vue&type=template&id=1f7efb14&"
import script from "./FBudget.vue?vue&type=script&lang=ts&"
export * from "./FBudget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports